// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CeliSpecOverviewTabQueryVariables = Types.Exact<{
  filter: Types.ChangeEventLineItemFilter;
}>;


export type CeliSpecOverviewTabQuery = { __typename?: 'Query', changeEventLineItems: Array<{ __typename?: 'ChangeEventLineItem', costType: Types.CostType, internalNote?: string | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, changeEvent: { __typename?: 'ChangeEvent', id: string, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } }, location: { __typename?: 'Location', id: string, name: string }, projectItem: { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined } } }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', useQuantity: boolean, id: string, name: string }> };

export type CeliSpecOverviewTabSaveCeliMutationVariables = Types.Exact<{
  celi: Types.SaveChangeEventLineItemInput;
}>;


export type CeliSpecOverviewTabSaveCeliMutation = { __typename?: 'Mutation', saveChangeEventLineItems: { __typename?: 'SaveChangeEventLineItemsResult', changeEventLineItems: Array<{ __typename?: 'ChangeEventLineItem', costType: Types.CostType, internalNote?: string | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, changeEvent: { __typename?: 'ChangeEvent', id: string, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } }, location: { __typename?: 'Location', id: string, name: string }, projectItem: { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined } } }> } };

export type CeliSpecOverviewTabChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', costType: Types.CostType, internalNote?: string | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, changeEvent: { __typename?: 'ChangeEvent', id: string, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean } }, location: { __typename?: 'Location', id: string, name: string }, projectItem: { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined } } };

export const CeliSpecOverviewTabChangeEventLineItemFragmentDoc = gql`
    fragment CeliSpecOverviewTabChangeEventLineItem on ChangeEventLineItem {
  ...Named
  changeEvent {
    id
    canEditLineItems {
      allowed
    }
  }
  costType
  internalNote
  location {
    ...Named
  }
  projectItem {
    ...Named
    item {
      id
      costCode {
        id
        displayName
      }
      tradeCategory {
        ...Named
      }
    }
  }
  specifications
  tradePartnerNote
  type
}
    ${NamedFragmentDoc}`;
export const CeliSpecOverviewTabDocument = gql`
    query CeliSpecOverviewTab($filter: ChangeEventLineItemFilter!) {
  changeEventLineItems(filter: $filter) {
    ...CeliSpecOverviewTabChangeEventLineItem
  }
  locations {
    ...Named
  }
  unitsOfMeasure {
    ...Named
    useQuantity
  }
}
    ${CeliSpecOverviewTabChangeEventLineItemFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useCeliSpecOverviewTabQuery__
 *
 * To run a query within a React component, call `useCeliSpecOverviewTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCeliSpecOverviewTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCeliSpecOverviewTabQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCeliSpecOverviewTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables> & ({ variables: CeliSpecOverviewTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>(CeliSpecOverviewTabDocument, options);
      }
export function useCeliSpecOverviewTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>(CeliSpecOverviewTabDocument, options);
        }
// @ts-ignore
export function useCeliSpecOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>;
export function useCeliSpecOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CeliSpecOverviewTabQuery | undefined, CeliSpecOverviewTabQueryVariables>;
export function useCeliSpecOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>(CeliSpecOverviewTabDocument, options);
        }
export type CeliSpecOverviewTabQueryHookResult = ReturnType<typeof useCeliSpecOverviewTabQuery>;
export type CeliSpecOverviewTabLazyQueryHookResult = ReturnType<typeof useCeliSpecOverviewTabLazyQuery>;
export type CeliSpecOverviewTabSuspenseQueryHookResult = ReturnType<typeof useCeliSpecOverviewTabSuspenseQuery>;
export type CeliSpecOverviewTabQueryResult = ApolloReactCommon.QueryResult<CeliSpecOverviewTabQuery, CeliSpecOverviewTabQueryVariables>;
export const CeliSpecOverviewTabSaveCeliDocument = gql`
    mutation CeliSpecOverviewTabSaveCeli($celi: SaveChangeEventLineItemInput!) {
  saveChangeEventLineItems(input: {changeEventLineItems: [$celi]}) {
    changeEventLineItems {
      ...CeliSpecOverviewTabChangeEventLineItem
    }
  }
}
    ${CeliSpecOverviewTabChangeEventLineItemFragmentDoc}`;

/**
 * __useCeliSpecOverviewTabSaveCeliMutation__
 *
 * To run a mutation, you first call `useCeliSpecOverviewTabSaveCeliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCeliSpecOverviewTabSaveCeliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [celiSpecOverviewTabSaveCeliMutation, { data, loading, error }] = useCeliSpecOverviewTabSaveCeliMutation({
 *   variables: {
 *      celi: // value for 'celi'
 *   },
 * });
 */
export function useCeliSpecOverviewTabSaveCeliMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CeliSpecOverviewTabSaveCeliMutation, CeliSpecOverviewTabSaveCeliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CeliSpecOverviewTabSaveCeliMutation, CeliSpecOverviewTabSaveCeliMutationVariables>(CeliSpecOverviewTabSaveCeliDocument, options);
      }
export type CeliSpecOverviewTabSaveCeliMutationHookResult = ReturnType<typeof useCeliSpecOverviewTabSaveCeliMutation>;
export type CeliSpecOverviewTabSaveCeliMutationResult = ApolloReactCommon.MutationResult<CeliSpecOverviewTabSaveCeliMutation>;